import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React, { useContext } from 'react';
import AnchorButton from '../../common/AnchorButton.js';
import DimmedLayer from '../../common/DimmedLayer.js';
import IcClose from '../../icons/IcClose.js';
import { MODAL_ID } from '../../../constants/modal.js';
import { ModalContext } from '../../../contexts/ModalContext.js';
import usePortal from '../../../hooks/usePortal.js';
import styles from './BottomModalNoticeWrapper.module.scss.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function BottomModalCloseButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-close'),
    onClick: onClick
  }, /*#__PURE__*/React.createElement(IcClose, {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB808\uC774\uC5B4 \uB2EB\uAE30"));
}
function BottomModalNoticeWrapper(_ref2) {
  var isPreRender = _ref2.isPreRender,
    underlineButton = _ref2.underlineButton,
    children = _ref2.children,
    onClickDimmedLayer = _ref2.onClickDimmedLayer,
    onClickCloseButton = _ref2.onClickCloseButton;
  var Portal = usePortal();
  var _useContext = useContext(ModalContext),
    isRunning = _useContext.isRunning,
    $container = _useContext.$container,
    close = _useContext.close;
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    className: cx('article', {
      hide: isPreRender
    }),
    ref: $container
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('layer', {
      show: isRunning
    }),
    id: MODAL_ID.BOTTOM_MODAL_NOTICE
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('inner')
  }, children, underlineButton ? ( /*#__PURE__*/React.createElement("div", {
    className: cx('area-button')
  }, /*#__PURE__*/React.createElement(AnchorButton, _objectSpread(_objectSpread({}, underlineButton), {}, {
    className: cx('button-text')
  }), underlineButton.text))) : null), /*#__PURE__*/React.createElement(BottomModalCloseButton, {
    onClick: onClickCloseButton !== null && onClickCloseButton !== void 0 ? onClickCloseButton : close
  })), /*#__PURE__*/React.createElement(DimmedLayer, {
    isShow: isRunning,
    onClick: onClickDimmedLayer !== null && onClickDimmedLayer !== void 0 ? onClickDimmedLayer : close
  })));
}

export { BottomModalNoticeWrapper as default };
